import { TenantWalletLedgerEntrySchema, type TenantWalletLedgerEntry } from '@kilat/shared';
import { collection, onSnapshot, orderBy, query, type Unsubscribe } from 'firebase/firestore';

import { db } from '../firebase.js';

/**
 * Sprint 98 — Operator wallet repos.
 *
 *   tenants/{tid}/walletLedger/{entryId} → wash collections + fees + payout
 *     debits. Owner + manager can read; server writes only (via toyyibPay
 *     webhook in Sprint 99 + the existing runPayoutBatch in Sprint 97).
 *
 * Returns entries ordered by `accruedAt DESC` so the /billing Balance
 * card renders newest-first without extra client sort. Single-field
 * order — no composite index needed.
 *
 * Silently drops per-doc schema-validation failures (consistent with
 * `createRepo.listSnapshot` policy). Surfaces listener-level errors
 * via the optional `onError` callback per [[feedback-no-dead-ends]].
 */
export function tenantWalletLedgerSnapshot(
  tenantId: string,
  cb: (entries: TenantWalletLedgerEntry[]) => void,
  onError?: (err: Error) => void,
): Unsubscribe {
  const ref = collection(db, `tenants/${tenantId}/walletLedger`);
  const q = query(ref, orderBy('accruedAt', 'desc'));
  return onSnapshot(
    q,
    (snap) => {
      const out: TenantWalletLedgerEntry[] = [];
      for (const d of snap.docs) {
        const parsed = TenantWalletLedgerEntrySchema.safeParse({ id: d.id, ...d.data() });
        if (parsed.success) out.push(parsed.data);
      }
      cb(out);
    },
    (err) => {
      if (onError) onError(err);
    },
  );
}
